var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"appear":"","name":"fade"}},[_c('div',{staticClass:"side-slider__root"},[_c('transition',{attrs:{"appear":"","name":"slide-from-right"}},[_c('div',{staticClass:"side-slider__content"},[_vm._t("default")],2)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }